import React, { useEffect, useMemo, useState } from "react";
import toast from "react-hot-toast";
import { useSelector } from "react-redux";
import formatDateForApi from "../../common/formatDateForApi";
import DashboardSkeleton from "../../common/DashboardSkeleton";
import Citiescommondropdown from "../../common/Citiescommondropdown";
import DaterangePicker from "../../common/Daterangepicker";
import { Search } from "lucide-react";

const formatCardAmount = (value) => {
  const amount = Number(value);
  return Number.isFinite(amount) ? amount.toFixed(2) : 0;
};

const categoryCellClasses = [
  "bg-yellow-50 text-yellow-800",
  "bg-purple-50 text-purple-800",
  "bg-rose-50 text-rose-800",
  "bg-green-50 text-green-800",
  "bg-indigo-50 text-indigo-800",
  "bg-teal-50 text-teal-800",
  "bg-orange-50 text-orange-800",
  "bg-pink-50 text-pink-800",
  "bg-cyan-50 text-cyan-800",
  "bg-red-50 text-red-800",
];

const Vehicleexpenses = () => {
  const cities = useSelector((state) => state?.cities?.citiesData);
  const apiUrl = process.env.REACT_APP_API_BASE_URL;
  const [cityFilter, setCityFilter] = useState("1");
  let token = localStorage.getItem("token");
  const [vehicleExpenseData, setVehicleExpenseData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [currentPage, setCurrentPage] = useState(1);
  const [activeFilter, setActiveFilter] = useState("All");
  const [searchTerm, setSearchTerm] = useState("");
  const rowsPerPage = 10;
  const today = new Date();
  today.setHours(23, 59, 59, 999);
  const oneMonthAgo = new Date();
  oneMonthAgo.setMonth(today.getMonth() - 1);
  const [selectionRange, setSelectionRange] = useState({
    startDate: oneMonthAgo,
    endDate: today,
    key: "selection",
  });

  const cityOptions = useMemo(() => {
    if (!cities) return [];
    return Object.entries(cities).map(([key, value]) => ({
      value: key,
      label: value,
    }));
  }, [cities]);

  const filteredVehicles = useMemo(() => {
    const normalizedSearch = searchTerm.trim().toLowerCase();
    if (!normalizedSearch) {
      return vehicleExpenseData?.vehicleList || [];
    }

    return (vehicleExpenseData?.vehicleList || []).filter((data) => {
      const vehicleNo = String(data?.licensePlate || "").toLowerCase();
      return vehicleNo.includes(normalizedSearch);
    });
  }, [searchTerm, vehicleExpenseData?.vehicleList]);

  const totalPages = Math.max(
    1,
    Math.ceil(filteredVehicles.length / rowsPerPage),
  );
  const startIndex = (currentPage - 1) * rowsPerPage;
  const paginatedVehicles = filteredVehicles.slice(
    startIndex,
    startIndex + rowsPerPage,
  );

  useEffect(() => {
    getDeliveryandPickupsDataAPI();
  }, []);

  useEffect(() => {
    setCurrentPage(1);
  }, [searchTerm]);

  const getDeliveryandPickupsDataAPI = async () => {
    if (!token) {
      return toast.error("Session Expired Close all the tab and signin again");
    }
    const formattedStartDate = formatDateForApi(
      selectionRange?.startDate,
      "start",
    );
    const formattedEndDate = formatDateForApi(selectionRange?.endDate, "end");
    setLoading(true);
    let query = "";
    if (cityFilter && cityFilter !== "All Cities") {
      query += `&cityId=${cityFilter}`;
    }
    const url = `${apiUrl}/api/dashboardreports/fleet-overall-dashboard?startDate=${formattedStartDate}&endDate=${formattedEndDate}${query}`;
    try {
      const response = await fetch(url, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
          Authorization: `${token}`,
        },
      });
      const data = await response.json();
      if (data?.statusCode === "0100") {
        setLoading(false);
        setVehicleExpenseData(data?.dataValues);
        setCurrentPage(1);
      } else {
        setLoading(false);
        toast.error(data?.msg);
      }
      return data;
    } catch (error) {
      return;
      setLoading(false);
      console.error("Error fetching Hub Names:", error);
    }
  };
  return (
    <>
      {loading ? (
        <div className="w-full">
          <DashboardSkeleton />
        </div>
      ) : (
        <div className="w-full">
          <div className="flex justify-between items-center gap-3 px-6 my-8">
            <h1 className="text-gray-900 text-2xl font-bold tracking-tight">
              Vehicle Expenses
            </h1>
            <div className="flex gap-4 justify-end">
              <DaterangePicker
                selectionRange={selectionRange}
                setSelectionRange={setSelectionRange}
                style={-10}
              />

              <div className="flex flex-wrap items-center gap-3 w-full md:w-auto">
                <div className="min-w-[180px] px-3 py-2 bg-white rounded-[10px] shadow-[0px_1px_2px_-1px_rgba(0,0,0,0.10)] shadow-[0px_1px_3px_0px_rgba(0,0,0,0.10)] outline outline-[0.80px] outline-offset-[-0.80px] outline-gray-200 inline-flex justify-start items-center gap-2">
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    viewBox="0 0 16 16"
                    fill="none"
                    className="flex-shrink-0 w-4 h-4"
                  >
                    <path
                      d="M8.4005 14.5327C9.6405 13.462 13.3332 9.99534 13.3332 6.66668C13.3332 5.25219 12.7713 3.89563 11.7711 2.89544C10.7709 1.89525 9.41433 1.33334 7.99984 1.33334C6.58535 1.33334 5.2288 1.89525 4.2286 2.89544C3.22841 3.89563 2.6665 5.25219 2.6665 6.66668C2.6665 9.99534 6.35917 13.462 7.59917 14.5327C7.71469 14.6195 7.85531 14.6665 7.99984 14.6665C8.14437 14.6665 8.28499 14.6195 8.4005 14.5327Z"
                      stroke="#99A1AF"
                      strokeWidth="1.33333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                    <path
                      d="M8 8.66666C9.10457 8.66666 10 7.77123 10 6.66666C10 5.56209 9.10457 4.66666 8 4.66666C6.89543 4.66666 6 5.56209 6 6.66666C6 7.77123 6.89543 8.66666 8 8.66666Z"
                      stroke="#99A1AF"
                      strokeWidth="1.33333"
                      strokeLinecap="round"
                      strokeLinejoin="round"
                    />
                  </svg>

                  <Citiescommondropdown
                    value={cityFilter}
                    onChange={setCityFilter}
                    options={[
                      { value: null, label: "All Cities" },
                      ...cityOptions,
                    ]}
                    placeholder="City"
                    className="flex-1 min-w-[80px]"
                    showSearch={true}
                  />
                </div>
              </div>

              <button
                onClick={() => {
                  getDeliveryandPickupsDataAPI();
                }}
                className="flex items-center gap-2 px-5 py-2.5 bg-blue-600 hover:bg-blue-700 text-white rounded-lg font-medium transition-all duration-300 shadow-md hover:shadow-lg"
              >
                <Search size={18} />
                Search
              </button>
            </div>
          </div>
          <div className="w-full p-8 flex flex-col gap-6 overflow-hidden">
            <div className="w-full grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5 gap-5">              
              <div className="flex-1 relative overflow-hidden bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 p-5 pt-7 inline-flex flex-col justify-start items-start gap-4">
                <div className="absolute top-0 left-0 right-0 h-2 bg-indigo-600" />

                <div className="self-stretch text-slate-500 text-xs font-semibold uppercase tracking-wide">
                  Total Fleet Spend
                </div>

                <div className="self-stretch flex flex-col gap-1">
                  <div className="self-stretch text-slate-900 text-xl font-bold">
                    ₹{" "}
                    {formatCardAmount(vehicleExpenseData?.summary?.totalFleetSpend)}
                  </div>
                </div>
              </div>

              <div className="flex-1 relative overflow-hidden bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 p-5 pt-7 inline-flex flex-col justify-start items-start gap-4">
                <div className="absolute top-0 left-0 right-0 h-2 bg-yellow-600" />

                <div className="self-stretch text-slate-500 text-xs font-semibold uppercase tracking-wide">
                  PMS Cost
                </div>

                <div className="self-stretch flex flex-col gap-1">
                  <div className="self-stretch text-slate-900 text-xl font-bold">
                    ₹{" "}
                    {formatCardAmount(
                      vehicleExpenseData?.summary?.totalPeriodicMaintenance,
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-1 relative overflow-hidden bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 p-5 pt-7 inline-flex flex-col justify-start items-start gap-4">
                <div className="absolute top-0 left-0 right-0 h-2 bg-purple-600" />

                <div className="self-stretch text-slate-500 text-xs font-semibold uppercase tracking-wide">
                  Running Repair Costs
                </div>

                <div className="self-stretch flex flex-col gap-1">
                  <div className="self-stretch text-slate-900 text-xl font-bold">
                    ₹{" "}
                    {formatCardAmount(
                      vehicleExpenseData?.summary?.totalRunningRepairCost,
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-1 relative overflow-hidden bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 p-5 pt-7 inline-flex flex-col justify-start items-start gap-4">
                <div className="absolute top-0 left-0 right-0 h-2 bg-green-600" />

                <div className="self-stretch text-slate-500 text-xs font-semibold uppercase tracking-wide">
                  Tinkering & Painting Costs
                </div>

                <div className="self-stretch flex flex-col gap-1">
                  <div className="self-stretch text-slate-900 text-xl font-bold">
                    ₹{" "}
                    {formatCardAmount(
                      vehicleExpenseData?.summary?.totalTinkeringPaintingCost,
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-1 relative overflow-hidden bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 p-5 pt-7 inline-flex flex-col justify-start items-start gap-4">
                <div className="absolute top-0 left-0 right-0 h-2 bg-cyan-600" />

                <div className="self-stretch text-slate-500 text-xs font-semibold uppercase tracking-wide">
                  Clutch Costs
                </div>

                <div className="self-stretch flex flex-col gap-1">
                  <div className="self-stretch text-slate-900 text-xl font-bold">
                    ₹{" "}
                    {formatCardAmount(
                      vehicleExpenseData?.summary?.totalClutchCost,
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-1 relative overflow-hidden bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 p-5 pt-7 inline-flex flex-col justify-start items-start gap-4">
                <div className="absolute top-0 left-0 right-0 h-2 bg-orange-600" />

                <div className="self-stretch text-slate-500 text-xs font-semibold uppercase tracking-wide">
                  Alignment Costs
                </div>

                <div className="self-stretch flex flex-col gap-1">
                  <div className="self-stretch text-slate-900 text-xl font-bold">
                    ₹{" "}
                    {formatCardAmount(
                      vehicleExpenseData?.summary?.totalAlignmentCost,
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-1 relative overflow-hidden bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 p-5 pt-7 inline-flex flex-col justify-start items-start gap-4">
                <div className="absolute top-0 left-0 right-0 h-2 bg-pink-600" />

                <div className="self-stretch text-slate-500 text-xs font-semibold uppercase tracking-wide">
                  Battery Costs
                </div>

                <div className="self-stretch flex flex-col gap-1">
                  <div className="self-stretch text-slate-900 text-xl font-bold">
                    ₹{" "}
                    {formatCardAmount(
                      vehicleExpenseData?.summary?.totalBatteryCost,
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-1 relative overflow-hidden bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 p-5 pt-7 inline-flex flex-col justify-start items-start gap-4">
                <div className="absolute top-0 left-0 right-0 h-2 bg-indigo-600" />

                <div className="self-stretch text-slate-500 text-xs font-semibold uppercase tracking-wide">
                  Wind Shield Costs
                </div>

                <div className="self-stretch flex flex-col gap-1">
                  <div className="self-stretch text-slate-900 text-xl font-bold">
                    ₹{" "}
                    {formatCardAmount(
                      vehicleExpenseData?.summary?.totalWindShieldCost,
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-1 relative overflow-hidden bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 p-5 pt-7 inline-flex flex-col justify-start items-start gap-4">
                <div className="absolute top-0 left-0 right-0 h-2 bg-teal-600" />

                <div className="self-stretch text-slate-500 text-xs font-semibold uppercase tracking-wide">
                  Tyres Costs
                </div>

                <div className="self-stretch flex flex-col gap-1">
                  <div className="self-stretch text-slate-900 text-xl font-bold">
                    ₹{" "}
                    {formatCardAmount(
                      vehicleExpenseData?.summary?.totalTyresRepairCost,
                    )}
                  </div>
                </div>
              </div>

              <div className="flex-1 relative overflow-hidden bg-white rounded-xl shadow-[0px_1px_2px_0px_rgba(0,0,0,0.05)] outline outline-1 outline-offset-[-1px] outline-slate-200 p-5 pt-7 inline-flex flex-col justify-start items-start gap-4">
                <div className="absolute top-0 left-0 right-0 h-2 bg-rose-600" />

                <div className="self-stretch text-slate-500 text-xs font-semibold uppercase tracking-wide">
                  Accident Costs
                </div>

                <div className="self-stretch flex flex-col gap-1">
                  <div className="self-stretch text-slate-900 text-xl font-bold">
                    ₹{" "}
                    {formatCardAmount(
                      vehicleExpenseData?.summary?.totalAccidentCost,
                    )}
                  </div>
                </div>
              </div>

             
            </div>
            <div className="w-full bg-white rounded-xl border border-gray-200 overflow-hidden">
              {/* Header */}
              <div className="flex justify-between items-center px-6 py-5">
                <h2 className="text-xs font-bold uppercase tracking-wide">
                  Vehicle-wise Expense Breakdown
                </h2>

                {/* Filter Buttons */}
                <div className="flex items-center gap-2">
                  <div className="flex items-center gap-2 rounded-md border border-gray-200 bg-gray-50 px-3 py-2">
                    <Search size={14} className="text-gray-400" />
                    <input
                      type="text"
                      value={searchTerm}
                      onChange={(e) => setSearchTerm(e.target.value)}
                      placeholder="Search vehicle no"
                      className="w-40 bg-transparent text-xs text-gray-700 outline-none"
                    />
                  </div>
                  <div className="flex border rounded-md p-1">
                    <button className="px-3 py-1 bg-blue-500 text-white text-[10px] rounded-md">
                      All
                    </button>
                  </div>
                  <div className="border-t bg-gray-50 px-6 py-3 text-xs text-gray-500">
                    Showing {Math.min(startIndex + 1, filteredVehicles.length)}-
                    {Math.min(
                      startIndex + rowsPerPage,
                      filteredVehicles.length,
                    )}{" "}
                    of {filteredVehicles.length}
                  </div>
                  <div className="flex items-center gap-2 rounded-md border border-gray-200 bg-gray-50 px-3 py-1 text-xs text-gray-500">
                    <button
                      onClick={() =>
                        setCurrentPage((prev) => Math.max(1, prev - 1))
                      }
                      disabled={currentPage === 1}
                      className="rounded border border-gray-300 bg-white px-2 py-1 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      Prev
                    </button>
                    <span>
                      Page {currentPage} of {totalPages}
                    </span>
                    <button
                      onClick={() =>
                        setCurrentPage((prev) => Math.min(totalPages, prev + 1))
                      }
                      disabled={currentPage === totalPages}
                      className="rounded border border-gray-300 bg-white px-2 py-1 disabled:cursor-not-allowed disabled:opacity-50"
                    >
                      Next
                    </button>
                  </div>
                </div>
              </div>

              {/* Scroll */}
              <div className="overflow-x-auto">
                <div className="w-full overflow-x-auto">
                  <table className="w-full min-w-[2200px] table-auto text-left">
                    <thead className="border-y bg-gray-50 text-[10px] font-semibold text-gray-500">
                      <tr>
                        {[
                          "Vehicle",
                          "Model",
                          "City",
                          "Group",
                          "PMS Count",
                          "PMS Spend",
                          "RR Count",
                          "RR Spend",
                          "Acc Count",
                          "Acc Spend",
                          "Tinkering Count",
                          "Tinkering Spend",
                          "Whl Align Count",
                          "Whl Align Spend",
                          "Whl Bal Count",
                          "Whl Bal Spend",
                          "Tires Count",
                          "Tires Spend",
                          "Batteries Count",
                          "Batteries Spend",
                          "Clutch Count",
                          "Clutch Spend",
                          "Windshield Count",
                          "Windshield Spend",
                          "Total",
                        ].map((heading) => (
                          <th
                            key={heading}
                            className="px-4 py-3 whitespace-nowrap align-top"
                          >
                            {heading}
                          </th>
                        ))}
                      </tr>
                    </thead>

                    <tbody className="text-xs font-semibold">
                      {vehicleExpenseData &&
                      vehicleExpenseData?.vehicleList?.length > 0 ? (
                        paginatedVehicles.length > 0 ? (
                          paginatedVehicles.map((data, index) => (
                            <tr
                              key={`${data?.licensePlate || "vehicle"}-${index}`}
                              className="border-b"
                            >
                              {[
                                data?.licensePlate,
                                data?.vehicleMakeText,
                                data?.cityText,
                                data?.vehicleGroupText,

                                data?.expenseList
                                  ?.totalPeriodicMaintenanceCount,
                                `₹${data?.expenseList?.totalPeriodicMaintenanceCostToCompany?.toLocaleString() || "0"}`,

                                data?.expenseList?.totalRunningRepairCount,
                                `₹${data?.expenseList?.totalRunningRepairCostToCompany?.toLocaleString() || "0"}`,

                                data?.expenseList?.totalAccidentCases,
                                `₹${data?.expenseList?.totalAccidentCostToCompany?.toLocaleString() || "0"}`,

                                data?.expenseList
                                  ?.totalTrinkiringAndPaintingCount,
                                `₹${data?.expenseList?.totalTrinkiringAndPaintingCostToCompany?.toLocaleString() || "0"}`,

                                data?.alignmentLogsDetails?.wheelAlignmentCount,
                                `₹${data?.alignmentLogsDetails?.wheelAlignmentCost?.toLocaleString() || "0"}`,

                                data?.alignmentLogsDetails?.wheelBalancingCount,
                                `₹${data?.alignmentLogsDetails?.wheelBalancingCost?.toLocaleString() || "0"}`,

                                data?.expenseList?.woTyresRepairCount,
                                `₹${data?.expenseList?.woTyresRepairCost?.toLocaleString() || "0"}`,

                                data?.batteryCount,
                                `₹${data?.totalBatteryCost?.toLocaleString() || "0"}`,

                                data?.expenseList?.woClutchRepairCount,
                                `₹${data?.expenseList?.wOclutchRepairCost?.toLocaleString() || "0"}`,

                                data?.expenseList?.windShieldRepairCount,
                                `₹${data?.expenseList?.windShieldRepairCost?.toLocaleString() || "0"}`,

                                `₹${data?.totalFleetSpend?.toLocaleString() || "0"}`,
                              ].map((value, cellIndex) => (
                                <td
                                  key={cellIndex}
                                  className={`px-4 py-4 whitespace-nowrap align-top text-left ${
                                    categoryCellClasses[Math.floor((cellIndex - 4) / 2)] || ""
                                  }`}
                                >
                                  {value ?? "-"}
                                </td>
                              ))}
                            </tr>
                          ))
                        ) : (
                          <tr>
                            <td
                              colSpan={25}
                              className="px-6 py-4 text-sm text-gray-500"
                            >
                              No matching vehicle found
                            </td>
                          </tr>
                        )
                      ) : (
                        <tr>
                          <td
                            colSpan={25}
                            className="px-6 py-4 text-sm text-gray-500"
                          >
                            No Data Found
                          </td>
                        </tr>
                      )}
                    </tbody>
                  </table>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default Vehicleexpenses;
